import { all, takeLatest, put, call } from 'redux-saga/effects';
import * as api from 'api/member';
import { PayloadAction } from '@reduxjs/toolkit';
import { connectMemberListActions } from '../reducer/connectMemberListSlice';
import { GetConnectMemberListParams } from 'types/member';

export function* getConnectMemberListSaga(action: PayloadAction<GetConnectMemberListParams>) {
  const { data } = yield call(api.getConnectMemberList, action.payload);
  if (data) {
    yield put(connectMemberListActions.getConnectMemberListSuccess(data));
  } else {
    yield put(connectMemberListActions.getConnectMemberListFailure(data));
  }
}

export default function* connectMemberListSaga() {
  yield all([
    takeLatest(connectMemberListActions.getConnectMemberList.type, getConnectMemberListSaga),
  ]);
}
